// Should return false for a brand new session (e.g. a first-time visitor), and true for later
// sessions
export function isSubsequentSession() {
  return !!localStorage.getItem("isSubsequentSession");
}

export function setIsSubsequentSession() {
  localStorage.setItem("isSubsequentSession", "true");
}
